export enum DeviceCodes {
    unknown = "-",

    glossmeter = "GLOSSMETER",

    iq = "IQ",
    detailometer = "DO",
    duo = "DU",
    novoGloss = "NG",
    flex = "FX",

    thicknessGauge = "CTG"
}
